import { types } from 'actions/polls/types';
import Mobilise from 'api/clients/Mobilise';
import showNotification, { typeNotification } from 'utils/showNotification';

const MobiliseClient = new Mobilise();

export const sendDailyPoll = (key, responseId) => async (dispatch) => {
    const data = {
        key,
        response_id: responseId,
    };

    dispatch({ type: types.POLL_WAS_SEND_REQUEST, payload: true });

    await MobiliseClient.sendDailyPoll(data)
        .then(({ data }) => {
            const { message } = data;
            dispatch({ type: types.POLL_WAS_SEND_REQUEST, payload: false });
            dispatch({ type: types.POLL_WAS_SEND_FAILURE, payload: false });
            dispatch({ type: types.POLL_WAS_SEND_SUCCESS, payload: true });
        })
        .catch((err) => {
            dispatch({ type: types.POLL_WAS_SEND_REQUEST, payload: false });
            dispatch({ type: types.POLL_WAS_SEND_FAILURE, payload: true });
        });
};

export const verifyTokenForPoll = (key, pollId) => async (dispatch) => {
    dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_REQUEST, payload: true });

    await MobiliseClient.verifyPollToken(key, pollId)
        .then((data) => {
            dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_REQUEST, payload: false });
            dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_FAILURE, payload: false });
            dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_SUCCESS, payload: true });
        })
        .catch((err) => {
            dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_REQUEST, payload: false });
            dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_FAILURE, payload: true });
        });
};

export const unsubscribeDailyPoll = (key) => async (dispatch) => {
    dispatch({ type: types.UNSUBSCRIBE_DAILY_POLL_REQUEST, payload: true });

    await MobiliseClient.unsubscribeDailyPoll(key)
        .then(({ data }) => {
            const { message } = data;
            dispatch({ type: types.UNSUBSCRIBE_DAILY_POLL_REQUEST, payload: false });
            dispatch({ type: types.UNSUBSCRIBE_DAILY_POLL_FAILURE, payload: false });
            dispatch({ type: types.UNSUBSCRIBE_DAILY_POLL_SUCCESS, payload: true });
            showNotification(message, typeNotification.success);
        })
        .catch((err) => {
            dispatch({ type: types.UNSUBSCRIBE_DAILY_POLL_REQUEST, payload: false });
            dispatch({ type: types.UNSUBSCRIBE_DAILY_POLL_FAILURE, payload: true });
            showNotification(err.key[0], typeNotification.error);
        });
};
